<template>
    <div class="content">
        <div class="book-reviews">
            <div class="book-reviews__overview">
                <div class="shell book-reviews__overview-inner">
                    <div class="book-reviews__image">
                        <img :src="pageData.image" :alt="pageData.title">
                    </div>

                    <div class="book-reviews__overview-entry">
                        <p>{{pageData.title}}</p>

                        <p class="book-reviews__meta">
                            {{pageData.author}}
                        </p>

                        <div class="book-reviews__rating">
                            <rating-stars :rating="pageData.rating"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="book-reviews__filters">
                <filter-bar
                    :filters="filters"
                    :activeValue="activeFilter"
                    @filter-change="val => setActiveFilter(val)"
                >
                    <template #default="{ filter }">
                        {{filter.content}}

                        <component :is="filter.icon" v-if="filter.icon" />
                    </template>
                </filter-bar>
            </div>

            <div class="book-details__content">
                <div class="shell">
                    <review-list :reviews="pageData.reviews" :activeFilter="activeFilter" />
                </div>
            </div>

            <div v-if="this.$store.getters.bookReviewsMoreToLoad" class="book-reviews__filters">
                <div class="shell">
                    <div>
                    <base-button @click="loadMore()" variant="feedback">
                        Altre...
                    </base-button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { ref, inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from "vuex";

import RatingStars from '@/components/rating-stars/rating-stars';
import BaseButton from '@/components/base-button/base-button';
import ReviewList from '@/blocks/review-list/review-list';
import FilterBar from '@/blocks/filter-bar/filter-bar';
import IconStar from '@/components/icons/icon-star/icon-star';

export default {
    name: 'BookReviews',

    components: {
        RatingStars,
        BaseButton,
        ReviewList,
        FilterBar,
        IconStar
    },

    setup() {
        const route = useRoute();
        const store = useStore();        
        const toast = inject("toast");        

        const pageData = ref({
            title: '',
            author: '',
            rating: '',
            image: '',
            reviews: []
        });

        const filters = ref([
            {
                id: 'filter1',
                content: 'Tutto',
                value:'tutto'
            },
            {
                id: 'filter2',
                content: 'Positive',
                value:'positive'
            },
            {
                id: 'filter3',
                content: 'Critiche',
                value:'critic'
            },
            {
                id: 'filter4',
                content: '5',
                icon: 'icon-star',
                value:'5'
            },
            {
                id: 'filter5',
                content: '4',
                icon: 'icon-star',
                value:'4'
            }
        ]);

        const activeFilter = ref(filters.value[0].value);

        const setActiveFilter = newFilter => {
            activeFilter.value = newFilter
        }

        onMounted(() => {
            store.commit('resetBookReviews');
            loadMore();
        })   
        
        function cover(book) {
            return book.cdn ? 
                book.cdn : 
                apipath + '/cache/images/book-cover/' + book.id;
        }
        
        function authors(book) {
            return book.authors.map(function(e) {
                return e.description;
            }).join(',') 
        }

        function loadMore() {
            store.dispatch('loadBookReviews', route.params.id)
            .then(function(result) {
                pageData.value.title = result.book.title;
                pageData.value.author = authors(result.book);
                pageData.value.image = cover(result.book);
                pageData.value.rating = result.book.rating;
                pageData.value.readByUsers = result.book.readByUsers;
                pageData.value.readByClasses = result.book.readByClasses;
                pageData.value.reviews = pageData.value.reviews.concat(result.reviews.data);
            })
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        }

        return {
            pageData,
            filters,
            activeFilter,
            setActiveFilter,
            authors,
            cover,
            loadMore
        }
    }
}
</script>
